var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"btn btn-sm",class:{'btn-outline-danger': _vm.customer.dnd, 'btn-outline-success': !_vm.customer.dnd},on:{"click":function($event){$event.preventDefault();return _vm.toggleDnD()}}},[(_vm.customer.dnd)?_c('font-awesome-icon',{attrs:{"icon":"bell-slash"}}):_c('font-awesome-icon',{attrs:{"icon":"bell"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }